import { render } from "./CreateNpc.vue?vue&type=template&id=46600730&scoped=true"
import script from "./CreateNpc.vue?vue&type=script&lang=js"
export * from "./CreateNpc.vue?vue&type=script&lang=js"

import "./CreateNpc.vue?vue&type=style&index=0&id=46600730&scoped=true&lang=css"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46600730"]])

export default __exports__